<template>
  <div class="list-item-description-icon mb-7">
    <div class="item mb-2">
      <div class="experience-icon">
        <inline-svg :src="require('@/assets/svg/experience-icon.svg')" />
      </div>
      <div class="description" v-if="isPlaceholder">
        <div class="d-flex flex-column mr-2">
          <span class="font-weight-bold">
            Previous Workplace
          </span>
        </div>
        <span>-/-/- - -/-/-</span>
      </div>
      <div class="description" v-else>
        <div class="d-flex flex-column">
          <span class="font-weight-bold"> {{ experience.jobTitle }} </span>
          <span> {{ experience.organisation }}</span>
        </div>
        <span> {{ dateRange }} </span>
      </div>
    </div>
    <div v-if="!isPlaceholder">
      {{ experience.keyResponsibilities }}
    </div>
    <div v-if="!isPlaceholder && experience.reasonForLeaving">
      <div class="secondary-text mt-2 mb-1">
        Reason for Leaving
      </div>
      {{ experience.reasonForLeaving }}
    </div>
  </div>
</template>

<script>
import { getDateRange, isValidDateRange } from "@/utils/time";
import InlineSvg from "vue-inline-svg";

export default {
  name: "ExperienceListItem",
  components: { InlineSvg },
  props: {
    experience: {
      type: Object,
      required: true
    },
    isPlaceholder: Boolean
  },
  computed: {
    dateRange() {
      const { startDate, endDate } = this.experience;
      if (!isValidDateRange([startDate, endDate])) {
        return "-/-/-";
      }
      return getDateRange({
        startDate,
        endDate,
        format: "Do MMM YY"
      });
    }
  }
};
</script>

<style lang="scss">
.experience-icon {
  margin-right: 10px;
  background-color: rgba($primary, 0.1);
  padding: 10px;
  border-radius: 4px;
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;

  path {
    fill: $primary;
  }
}
</style>
